module.exports = __webpack_public_path__ + "img/internazionale-logo-icon.efdcb753.png";